<template>
  <div>
    <topmenu></topmenu>

    <div class="container">
      <div class="list-con">
        <div class="left">
          <div class="nav">
            <span class="text">当前位置：首页 <span class="ico"><img src="../../assets/img/6.png" alt=""></span> {{menutext}}</span>
          </div>
          <wenzhang></wenzhang>
        </div>
        <div class="right">
          <rightpic></rightpic>
          <rightnews :myProp="toChildA" :myPropType="toChildAType"></rightnews>
        </div>
      </div>
    </div>
    <bottomfooter></bottomfooter>
  </div>
</template>

<script>
import topmenu from '@/views/front/components/topmenu';
import bottomfooter from '@/views/front/components/bottomfooter';
import rightnews from '@/views/front/components/rightnews';
import rightpic from '@/views/front/components/rightpic';
import wenzhang from '@/views/front/components/wenzhang';

export default {
  name: 'List',
  components: {
    topmenu,
    bottomfooter,
    rightnews,
    rightpic,
    wenzhang,

  },
  data() {
    return {
       toChildA: '通知公告',
       toChildAType:'4',
       menutext:''
    };
  },
  mounted(){
      this.menutext = this.$route.query.menutext;
  },
  methods: {}
};
</script>

<style scoped>
  .list-con{
    display: flex;
    justify-content: space-between;
  }
  .left{
    width:60%;
  }
  .right{
    width:35%;
  }
  .nav{
    background:#efefef;
    padding:10px 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Front/Article.vue